import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import {
    fetchBusinessUnitsSuccess,
    showBusinessUnitMessage,
    onSaveBusinessUnitSuccess,
    onDeleteBusinessUnitSuccess,
    addFavouriteBusinessUnitSuccess,
} from 'actions/businessUnit';
import {
    ON_SAVE_BUSINESS_UNIT,
    FETCH_ALL_BUSINESS_UNIT,
    ON_DELETE_BUSINESS_UNIT,
    ADD_FAVOURITE_BUSINESS_UNIT,
} from 'constants/ActionTypes';
import { fetchDataRequest, addOrUpdateDataRequest, updateDataRequest, deleteDataRequest  } from 'services/ApiService';
import { apiErrorMessageFormatter } from 'services/errorService';
import { ORGID_PATH_PARAM } from 'constants/api';

const currentOrg = (state) => state.orgs.selectedOrg;
const getBusinessUnitList = (state) => state.businessUnits.allBusinessUnit;

export function* fetchBusinessUnits() {
    try {
        const selectedOrg = yield select(currentOrg);
        const fetchedBusinessUnits = yield call(
            fetchDataRequest,
            'businessUnits',
            [ORGID_PATH_PARAM],
            [selectedOrg ?.id]
        ) || [];
        yield put(fetchBusinessUnitsSuccess(fetchedBusinessUnits));
    } catch (error) {
        yield put(showBusinessUnitMessage(apiErrorMessageFormatter(error)));
    }
}

export function* deleteBusinessUnit({ payload }) {
    try {
        // payload should be the businessUnitId
        const selectedOrg = yield select(currentOrg);
        yield call(
            deleteDataRequest,
            'deleteBusinessUnit',
            'Deleting business unit '.concat(payload),
            [ORGID_PATH_PARAM, 'businessUnitId'],
            [selectedOrg ?.id, payload]
        ) || [];
        yield put(onDeleteBusinessUnitSuccess(payload)); // just dispatch the id as the reducer will remove from the item from the list
    } catch (error) {
        yield put(showBusinessUnitMessage(apiErrorMessageFormatter(error)));
    }
}

export function* saveBusinessUnit({ payload }) {
    try {
        const selectedOrg = yield select(currentOrg);
        const allBusinessUnits = yield select(getBusinessUnitList);
        let finalPayload = { ...payload };
        // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is
        if (payload ?.orgid === '') {
            finalPayload = { ...payload, orgid: selectedOrg ?.id };
        }
        const savedBusinessUnit = yield call(
            addOrUpdateDataRequest,
            allBusinessUnits,
            finalPayload,
            'addBusinessUnit',
            'updateBusinessUnit',
            [ORGID_PATH_PARAM],
            [selectedOrg.id]);
        yield put(onSaveBusinessUnitSuccess(savedBusinessUnit)); // is the payload
    } catch (error) {
        yield put(showBusinessUnitMessage(apiErrorMessageFormatter(error)));
    }
}

/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */
export function* addFavouriteBusinessUnit({ payload }) {
    try {
        const allBusinessUnits = yield select(getBusinessUnitList);
        const selectedOrg = yield select(currentOrg);
        const filtered = allBusinessUnits.filter((entry) => entry ?.id === payload ?.id);

        if (filtered ?.length > 0) {
            const entry = filtered[0];
            const updatedBusinessUnit = {
                ...entry,
                starred: !payload.starred
            };
            const auditMsg = 'Updating starred setting to '.concat(updatedBusinessUnit ?.starred).concat(' for businessUnit ').concat(updatedBusinessUnit ?.id);
            yield call(
                updateDataRequest,
                updatedBusinessUnit,
                'updateBusinessUnit',
                auditMsg,
                [ORGID_PATH_PARAM],
                [selectedOrg.id],
            );
            // now just pass on the original payload as the reducer will filter the list as per the state of the selection
            yield put(addFavouriteBusinessUnitSuccess(payload));
        }
    } catch (error) {
        yield put(showBusinessUnitMessage(error.messages));
    }
}

export function* fetchBusinessUnitsSaga() {
    yield takeEvery(FETCH_ALL_BUSINESS_UNIT, fetchBusinessUnits);
}

export function* saveBusinessUnitSaga() {
    yield takeEvery(ON_SAVE_BUSINESS_UNIT, saveBusinessUnit);
}

export function* deleteBusinessUnitSaga() {
    yield takeEvery(ON_DELETE_BUSINESS_UNIT, deleteBusinessUnit);
}

export function* addFavouriteBusinessUnitSaga() {
    yield takeEvery(ADD_FAVOURITE_BUSINESS_UNIT, addFavouriteBusinessUnit);
}

export default function* rootSaga() {
    yield all([
        fork(fetchBusinessUnitsSaga),
        fork(saveBusinessUnitSaga),
        fork(deleteBusinessUnitSaga),
        fork(addFavouriteBusinessUnitSaga),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/businessUnit.js